import LocationOnRounded from '@mui/icons-material/LocationOnRounded';
import { Box, Tooltip } from '@mui/material';
import React, { FC } from 'react';

import { tooltips } from '@components/Capture/helper';
import { CommonStyles, StyledIcon, sxMR0 } from '@components/Capture/icons/styles';
import { CapturePiece } from '@components/Capture/types';
import noop from 'lodash/fp/noop';

interface ILocationIconProps {
  capturePiece: CapturePiece | null;
  onClick?: () => void;
}

const LocationIcon: FC<ILocationIconProps> = ({ onClick, capturePiece }) => {
  if (!capturePiece) {
    return null;
  }
  const { piece } = capturePiece;

  return (
    <Box onClick={!piece ? noop : onClick} sx={{ ...CommonStyles, ...sxMR0 }}>
      <Tooltip title={tooltips.LocationOnRounded} arrow>
        <LocationOnRounded sx={StyledIcon(!piece ? 'action.disabled' : undefined)} />
      </Tooltip>
    </Box>
  );
};

export { LocationIcon };
